var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    _vm._b(
      {
        model: {
          value: _vm.formValue,
          callback: function ($$v) {
            _vm.formValue = $$v
          },
          expression: "formValue",
        },
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-card",
        [
          _c(
            "div",
            { staticClass: "text-xs-center title-icon" },
            [
              _c(
                "v-icon",
                { staticClass: "warning--text", attrs: { large: "" } },
                [_vm._v("warning")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-title",
            { staticClass: "headline title" },
            [_vm._t("title")],
            2
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c("v-card-text", [_vm._t("text")], 2),
          _vm._v(" "),
          _c("v-card-actions", [_vm._t("actions")], 2),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }